import { forwardRef, ComponentPropsWithoutRef } from 'react'
import { cx } from 'tusk-ui/utils'
import Input from './Input'
import './SelectInput.css'

export interface SelectInputRootProps
    extends ComponentPropsWithoutRef<typeof Input>,
        ComponentPropsWithoutRef<'select'> {}

const SelectInputRoot = forwardRef<HTMLSelectElement, SelectInputRootProps>(({ className, invalid, ...props }, ref) => {
    return (
        <Input ref={ref} invalid={invalid} className={cx('', className)}>
            <select ref={ref} className={cx('mmth-select', className)} {...props} />
        </Input>
    )
})

const SelectInputOption = forwardRef<HTMLOptionElement, ComponentPropsWithoutRef<'option'>>(
    ({ className, ...props }, ref) => {
        return <option ref={ref} className={cx('', className)} {...props} />
    }
)

export { SelectInputRoot as Root, SelectInputOption as Option }
